import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useController, useForm, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

import './SwitchButtons.scss';

export default function SwitchButtons(props) {
  const { name, buttonOne, buttonTwo, selectedValue, className } = props;

  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm; // Fallback if used outside FormProvider
  const {
    field,
    fieldState: { error }
  } = useController({ name, control });

  useEffect(() => {
    field.onChange(selectedValue);
  }, [selectedValue]);

  return (
    <Row className={`switchButtons ${className}`}>
      <Col xs={6} className="pe-1">
        <div className='form-group mb-3'>
          <Button
            variant="outlined"
            className={selectedValue === buttonOne.selectedValue ? "primary-border-color buttonSelected" : "button-border"}
            startIcon={buttonOne.icon}
            id={buttonOne.name}
            onClick={buttonOne.onClick}
            fullWidth
            color='inherit'
            >
            {buttonOne.name}
          </Button>
          <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">{error?.message}</span>
        </div>
      </Col>

      <Col xs={6} className="ps-1">
        <div className='form-group mb-3'>
          <Button
            variant="outlined"
            className={selectedValue === buttonTwo.selectedValue ? "primary-border-color buttonSelected" : "button-border"}
            startIcon={buttonTwo.icon}
            id={buttonTwo.name}
            onClick={buttonTwo.onClick}
            fullWidth
            color='inherit'
          >
            {buttonTwo.name}
          </Button>
        </div>
      </Col>
    </Row>
  );
}

SwitchButtons.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  buttonOne: PropTypes.object.isRequired,
  buttonTwo: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired
};